<template>
  <vue-numeric-input
    v-bind="$attrs"
    v-on="$listeners"
    size="8rem"
  ></vue-numeric-input>
</template>


<script>
import VueNumericInput from "vue-numeric-input";

export default {
  name: "numeric-input",
  components: {
    VueNumericInput,
  },
};
</script>


<style lang="scss" scoped>

::v-deep .numeric-input {
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 35% !important;
}

::v-deep button {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}
</style>
